import { useTranslation } from 'react-i18next';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import { useState, useEffect } from "react";

const Location = ({ propiedad }) => {
    const { t } = useTranslation();

    const [coordinates, setCoordinates] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchCoordinates = async () => {
        setCoordinates([parseFloat(propiedad.latitud), parseFloat(propiedad.longitud)]);
        setLoading(false);
    };

    useEffect(() => {
        if (propiedad) {
            fetchCoordinates();
        }
    }, [propiedad]);


    return (

        <div className="mb-6 row" id="ubicacion">
            <div className="col-sm-6 d-flex flex-column justify-content-center align-items-start">
                <h2 className="text-center h1 text-sm-start">{t("Ubicación")}</h2>
                <figure className="mb-4 offset-1 col-10 d-sm-none">
                    <img className="w-100" src="https://pro-static.h10hotels.com/gallery/MapaHI.jpg" alt="Mapa" />
                </figure>
                <div className="col-md-auto offset-md-1 offset-xl-2">
                    <app-read-more _nghost-ng-c137762624="">
                        <div _ngcontent-ng-c137762624="" className="js-txtoverflow" dangerouslySetInnerHTML={{ __html: propiedad.vecind }}>
                        </div>
                    </app-read-more>
                    <div className="o-list-btns">
                        <a target="_blank" className="btn btn-secondary" href={`https://www.google.com/maps/search/?api=1&query=${propiedad.latitud}%2C${propiedad.longitud}`}>{t("VER EN GOOGLE MAPS")}</a>
                    </div>
                </div>
            </div>
            <div className="offset-sm-1 col-sm-5 d-none d-sm-block">
                <figure className="o-cont-fullw o-cont-md-fullw__right not-xl-fullw__right">
                    {(!loading) ? (
                        <MapContainer
                            center={coordinates}
                            zoom={16}
                            scrollWheelZoom={false}
                            style={{ height: "300px", width: "550px", zIndex: "1" }}
                        >
                            <TileLayer
                                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            />
                            <Marker position={coordinates} />
                        </MapContainer>
                    ) : (
                        <div
                            style={{
                                height: "100%",
                                width: "100%",
                                backgroundColor: "#f8f9fa",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: "8px"
                            }}
                        >
                            <div className="text-center text-muted">
                                <div className="mb-2 spinner-border spinner-border-sm" role="status"></div>
                                <small>{t("Cargando mapa...")}</small>
                            </div>
                        </div>
                    )}
                </figure>
            </div>
        </div>


    );
};

export default Location;
